if (!customElements.get('pickup-availability-locations')) {
  class PickupAvailabilityLocations extends HTMLElement {
    constructor() {
      super();
    
      this.dropdowns = this.querySelectorAll('.js-location-dropdown');
      this.handleClick = this.handleClick.bind(this);

      if (this.dropdowns?.length > 0) {
        this.dropdowns.forEach((d) => {
          d.addEventListener('click', this.handleClick);
        });
      }
    }

    handleClick(e) {
      const listItem = e.target.closest('li');

      if (!listItem) return;

      listItem.dataset.expanded = listItem.dataset.expanded === "true" ? "false" : "true";
    }

    disconnectedCallback() {
      if (this.dropdowns?.length > 0) {
        this.dropdowns.forEach((d) => {
          d.addEventListener('click', this.handleClick)
        })
      }
    }
  }

  customElements.define('pickup-availability-locations', PickupAvailabilityLocations);
}
